import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';


import { formattedDollar, formattedNumber } from '../../../../../utils/formatterHelpers';
import '../../../../../grid.css';
import './loanpoints.css';

class LoanPoints extends React.Component {
    static propTypes = {
        annualResults: PropTypes.object.isRequired,
        setMosaicTerm: PropTypes.func.isRequired,
        includeESS: PropTypes.bool.isRequired,
        essPrice: PropTypes.number.isRequired,
        cashprice: PropTypes.number.isRequired,
        systemSize: PropTypes.number.isRequired,
        annualInflation: PropTypes.number.isRequired,
        taxRate: PropTypes.number.isRequired,
        loanProvider: PropTypes.string.isRequired,
        loanTerm: PropTypes.number.isRequired,
        mosaicFee: PropTypes.number.isRequired,
        mosaicDownPayment: PropTypes.number.isRequired,
        downPayment: PropTypes.number.isRequired,
        mosaicTerm: PropTypes.number.isRequired,
        projectState: PropTypes.number.isRequired,
        resiToggle: PropTypes.bool.isRequired,
    };

    handleMosaicTermChange(value) {
        const { setMosaicTerm } = this.props;
        setMosaicTerm(value);
    }

    render() {
        const {
            annualResults,
            annualInflation,
            cashprice,
            systemSize,
            taxRate,
            loanProvider,
            resiToggle,
            mosaicFee,
            mosaicDownPayment,
            downPayment,
            mosaicTerm,
            loanTerm,
            projectState,
        } = this.props;

        let finalPrice = cashprice;
        if (loanProvider === 'mosaic') {
            finalPrice = (cashprice - mosaicDownPayment) * mosaicFee + mosaicDownPayment;
        }

        let desposit = downPayment;
        if (loanProvider === 'mosaic') {
            desposit = mosaicDownPayment;
        }

        let financeTerm = 0;
        if (loanProvider === 'mosaic') {
            financeTerm = mosaicTerm;
        }
        if (loanProvider === 'custom') {
            financeTerm = loanTerm;
        }
        let totalSavings = 0;
        if (loanProvider === 'mosaic') {
            totalSavings = formattedNumber(annualResults[30].cumulativeMosaicSavings);
        }
        if (loanProvider === 'custom') {
            totalSavings = formattedNumber(annualResults[30].cumulativeLoanSavings);
        }

        let incentive = '';
        if (projectState === 1) {
            incentive = 'SGIP';
        }
        if (projectState === 2) {
            incentive = 'SMART';
        }
        if (projectState === 3) {
            incentive = 'RECs';
        }

        const kW = formattedDollar(systemSize / 1000);

        const avgMonthlyIncentives =
            annualResults[financeTerm / 12].cumulativeIncentives / financeTerm;

        return (
            <Paper className="loanSpecs">
                <div className="row">
                    <h1 className="titleCase">{loanProvider} Facts</h1>
                </div>
                <div className="row">
                    <div className="col span-1-of-2">
                        <ul className="align">
                            <li>
                            Total Incentives:
                            ${formattedNumber(annualResults[30].cumulativeTotalAnnualIncentives)}
                            </li>
                            <li>
                                Deposit: ${formattedNumber((desposit))}
                            </li>
                            {loanProvider === 'mosaic' ?
                                <div>
                                    <li>
                                        Before Prepayment:
                                        ${formattedNumber(annualResults[1].annualHomeLoanPayment / 12)}/m
                                    </li>
                                    <li>
                                        After Prepayment:
                                        ${formattedNumber(annualResults[3].annualHomeLoanPayment / 12)}/m
                                    </li>
                                </div>
                                : null }
                            {loanProvider === 'custom' ?
                                <div>
                                    <li>
                                        Loan Payment:
                                        ${formattedNumber(annualResults[1].loanPayment / 12)}/m
                                    </li>
                                </div>
                                : null }
                            {projectState !== 4 ?
                                <li>
                                    Avg. {incentive} During Loan:
                                    ${formattedNumber(avgMonthlyIncentives)}/m
                                </li>
                                : null }

                            <li>
                                Lifetime Production:&nbsp;
                                {formattedNumber(annualResults[30].cumulativeSystemProduction)} kWh
                            </li>
                        </ul>
                    </div>
                    <div className="col span-1-of-2">
                        <ul className="align">
                            <li> System Size: {kW} kW</li>
                            <li>Utility Inflation: {annualInflation} %</li>
                            {resiToggle ? null : <li>Tax Rate: {taxRate} %</li>}
                            <li> System Price: ${formattedDollar(finalPrice)}</li>
                            <li> Total Savings: ${totalSavings}</li>
                            <li>
                                Avoided Utility Cost:
                                ${formattedNumber(annualResults[30].cumulativeSolarSavings)}
                            </li>
                        </ul>
                    </div>
                </div>
            </Paper>
        );
    }
}

export default LoanPoints;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/LoanPoints/LoanPoints.js